import { Button } from "../Button/index.js";
import SVG from "react-inlinesvg";
import { ReplyActions } from "./ReplyBox.js";
import { useAppStore } from "../../stores/appStore.js";
import { useCommentStore } from "../../stores/commentStore.js";
import { useState } from "react";

export default function CommentContentEditor({ comment, setIsEditing, setIsEditingReply }) {
  const [content, setContent] = useState(comment.content);
  const updateComment = useCommentStore((state) => state.updateComment);
  const isMac = useAppStore((state) => state.isMac);
  const handleCancel = () => {
    setIsEditing(false);
    if (setIsEditingReply && typeof setIsEditingReply === "function") {
      setIsEditingReply(false);
    }
  };
  const handleSubmit = () => {
    updateComment(comment.id, content, comment.parentId);
    setIsEditing(false);
    if (setIsEditingReply && typeof setIsEditingReply === "function") {
      setIsEditingReply(false);
    }
  };
  return (
    <>
      <textarea
        value={content}
        className="comment-card-edit-input"
        autoFocus
        onFocus={(e) => {
          e.target.style.height = "auto";
          e.target.style.height = e.target.scrollHeight + "px";
        }}
        onChange={(e) => {
          setContent(e.target.value);
          e.target.style.height = "auto";
          e.target.style.height = e.target.scrollHeight + "px";
        }}
        onKeyDown={(e) => {
          if ((e.metaKey || e.ctrlKey) && e.key === "Enter") {
            e.preventDefault();
            handleSubmit();
          }
          if (e.key === "Escape") {
            handleCancel();
          }
        }}
      />
      <ReplyActions>
        <Button
          className="use-component-styles"
          small
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          className="use-component-styles"
          primary
          onClick={handleSubmit}
        >
          Save
          <SVG
            src={isMac ? "/assets/keyboard-shortcuts/command-key.svg" : "/assets/keyboard-shortcuts/control-key-pc.svg"}
            aria-hidden="true"
            height={19}
            width={21}
            style={{
              marginLeft: "5px",
              border: "2px solid rgba(255, 255, 255, 0.4)",
              borderRadius: "5px",
            }}
          />
          <SVG
            src="/assets/keyboard-shortcuts/enter-key.svg"
            aria-hidden="true"
            height={19}
            width={21}
            style={{
              border: "2px solid rgba(255, 255, 255, 0.4)",
              borderRadius: "5px",
            }}
          />
        </Button>
      </ReplyActions>
    </>
  );
}
